import { DialogContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import AudioInputList from './AudioInputList/AudioInputList'
import AudioOutputList from './AudioOutputList/AudioOutputList'
import VideoInputList from './VideoInputList/VideoInputList'
import './DeviceSelector.css'

const useStyles = makeStyles({
    listSection: {
        fontFamily: 'Avenir, AvenirBold',
        margin: '2em 0',
        '&:first-child': {
            margin: '1em 0 2em 0',
        },
    },
})

export function DeviceSelector({ className, hidden }) {
    const classes = useStyles()

    console.count('DeviceSelector Component')

    return (
        <DialogContent className={className} hidden={hidden}>
            <div className={classes.listSection}>
                <VideoInputList />
            </div>
            <div className={classes.listSection}>
                <AudioInputList />
            </div>
            <div className={classes.listSection}>
                <AudioOutputList />
            </div>
        </DialogContent>
    )
}
